const registerHighlightLanguages = () => {
  require('prismjs/components/prism-jsx.min');
  require('prismjs/components/prism-python.min');
};

export default registerHighlightLanguages;